<template>
  <div class="video-player-MpegPlayer-king-container">
    <video ref="myPlayerDom" class="MpegPlayer-style" :controls="videoConfig.controls" :muted="videoConfig.muted" :autoplay="videoConfig.autoplay"></video>
  </div>
</template>

<script>
import MpegPlayer from "mpegts.js";

export default {
  name: "MpegVideoPlayer",
  props: {
    idIndex: {
      type: Number,
      default: 999,
    },
    videoUrl: {
      type: String,
      required: true,
    },
    videoConfigFa: {
      type: Object,
      default: () => ({}),
    },
    configFa: {
      type: Object,
      default: () => ({}),
    },
    configBasicFa: {
      type: Object,
      default: () => ({}),
    },
    playbackRate: {
      type: Number,
      default: 1,
      validator: val => [1, 2, 4, 6, 8].includes(val),
    },
  },
  data() {
    return {
      myPlayerObj: null,
      errorFlag: false,
      hasEverPlayed: false,
      errorCount: 0,
      MAX_ERROR_COUNT: 3,
      animationFrameId: null,
      defaultVideoConfig: {
        muted: true,
        autoplay: true,
        controls: false,
      },
      defaultConfig: {
        hasAudio: false,
        hasVideo: true,
        isLive: true,
      },
      defaultConfigBasic: {
        enableWorker: true,
        enableStashBuffer: true,
        autoCleanupSourceBuffer: true,
        reuseRedirectedURL: true,
        fixAudioTimestampGap: true,
        seekType: "range",
        autoLoad: true,
        statisticsInfoReportInterval: 3000,
      },
    };
  },
  computed: {
    videoConfig() {
      return Object.assign({}, this.defaultVideoConfig, this.videoConfigFa);
    },
  },
  watch: {
    videoUrl: {
      handler() {
        this.destroyPlayer();
        this.init();
      },
    },
    playbackRate: {
      handler(newRate) {
        const video = this.$refs.myPlayerDom;
        if (video) {
          video.playbackRate = newRate;
        }
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
  methods: {
    init() {
      if (!MpegPlayer.isSupported()) {
        this.errorFlag = true;
        this.$emit("player-created", {
          index: this.idIndex,
          player: null,
          err: true,
        });
        return;
      }

      const video = this.$refs.myPlayerDom;
      const config = Object.assign({}, this.defaultConfig, this.configFa);
      const configBasic = Object.assign({}, this.defaultConfigBasic, this.configBasicFa);

      this.myPlayerObj = MpegPlayer.createPlayer(
        {
          type: "flv",
          url: this.videoUrl,
          ...config,
        },
        {
          ...configBasic,
        }
      );

      this.myPlayerObj.attachMediaElement(video);
      this.myPlayerObj.load();
      this.myPlayerObj.play();
      video.playbackRate = this.playbackRate;

      // 精准错误监听
      this.myPlayerObj.on(MpegPlayer.Events.ERROR, (type, detail) => {
        console.warn("[mpegts.js ERROR]", type, detail);
        if (type === MpegPlayer.ErrorTypes.NETWORK_ERROR || type === MpegPlayer.ErrorTypes.MEDIA_ERROR) {
          this.errorFlag = true;
          this.$emit("player-created", {
            index: this.idIndex,
            player: this.myPlayerObj,
            err: true,
          });
        }
      });

      // video 标签兜底监听
      video.addEventListener("error", e => {
        console.warn("[video error]", e);
        this.errorFlag = true;
        this.$emit("player-created", {
          index: this.idIndex,
          player: this.myPlayerObj,
          err: true,
        });
      });

      // 非致命提示，仅记录日志
      video.addEventListener("waiting", () => console.warn("[video] 等待数据中 (waiting)"));
      video.addEventListener("stalled", () => console.warn("[video] 数据加载中断 (stalled)"));

      //  播放成功监听（只抛一次）
      video.addEventListener("canplay", () => {
        if (!this.hasEverPlayed) {
          this.hasEverPlayed = true;
          this.errorFlag = false;
          this.$emit("player-created", {
            index: this.idIndex,
            player: this.myPlayerObj,
            err: false,
          });
          console.log("✅ 播放成功 canplay");
        }
      });

      // 可选兜底检测
      this.checkVideoPlaySuccess(video);
    },

    checkVideoPlaySuccess(video) {
      let checkCount = 0;
      const maxCheck = 30;
      const interval = 300;
      const check = () => {
        if (!video) return;
        const canPlay = video.readyState >= 3;
        if (canPlay && !this.hasEverPlayed) {
          this.hasEverPlayed = true;
          this.errorFlag = false;
          this.$emit("player-created", {
            index: this.idIndex,
            player: this.myPlayerObj,
            err: false,
          });
        } else {
          checkCount++;
          if (checkCount < maxCheck) {
            setTimeout(() => {
              this.animationFrameId = requestAnimationFrame(check);
            }, interval);
          } else {
            console.warn("播放源监测超时，检查播放源是否正常");
          }
        }
      };
      check();
    },

    destroyPlayer() {
      if (this.animationFrameId) {
        cancelAnimationFrame(this.animationFrameId);
        this.animationFrameId = null;
      }
      if (this.myPlayerObj) {
        try {
          this.myPlayerObj.pause();
          this.myPlayerObj.unload();
          this.myPlayerObj.detachMediaElement();
          setTimeout(() => {
            try {
              this.myPlayerObj.destroy();
            } catch (e) {
              console.warn("MpegPlayer destroy 出现异常", e);
            }
            this.myPlayerObj = null;
          }, 100);
        } catch (e) {
          console.error("销毁播放器失败", e);
        }
      }
    },
  },
  beforeDestroy() {
    this.destroyPlayer();
  },
};
</script>

<style scoped>
.video-player-MpegPlayer-king-container {
  min-height: 169px;
  min-width: 300px;
  width: 100%;
  height: 100%;
  background: #000;
  position: relative;
}
.MpegPlayer-style {
  width: 100% !important;
  height: 100% !important;
}
</style>
